export default {
    namespaced: true,
    state: {
        login: null
    },
    mutations: {
        SET_LOGIN(state, login) {
            state.login = login
        },
    },
    actions: {
        async loginUser({ commit }, {email, password}) {
            const login = {email, password};

            const response = await fetch(`${api_url}/auth/user/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(login)
            });

            const json_response = await response.json()

            if( json_response.error ) {
                setTimeout(()=>{
                    alert(json_response.error)
                }, 800)
            } else if( json_response.session ) {
                commit('SET_LOGIN', {
                    user: json_response.user,
                    session: json_response.session
                });
            }
        },
        async preRegisterUser({ commit }, {email}) {
            const response = await fetch(`${api_url}/user/pre-register`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            const json_response = await response.json();

            if( json_response.status !== 'success' ) {
                alert(json_response.message);
            }
        }
    }
};